function isResponseOk(res) {
    if (res.meta && res.meta.code) {
        return res.meta.code < 300 && res.meta.code >= 200;
    }
    return false;
}

export default isResponseOk;



/** WEBPACK FOOTER **
 ** ./app/utils/functions/isResponseOk.js
 **/